import React from 'react';
import AppModern from './App_Modern';

const App: React.FC = () => {
  return <AppModern />;
};

export default App;